import CommunitiesLayout from "./Layout"
import BookmarksApp from "../../communities/pages/bookmarks/App"

const Bookmarks = (props) => {
  return <BookmarksApp />
}
Bookmarks.layout = (page) => <CommunitiesLayout>{page}</CommunitiesLayout>
export default Bookmarks
